import {ModuleWithProviders, NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MinusSignToParens } from "app/pipes/minus-sign-to-parens.pipe";
import { PlaceholderPipe } from "app/pipes/placeholder.pipe";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {AdvisorContactComponent} from "app/modules/shared/advisor-contact.component";
import { VerticalNavComponent } from './vertical-nav/vertical-nav.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        MinusSignToParens,
        PlaceholderPipe,
        AdvisorContactComponent,
        VerticalNavComponent
    ],
    exports: [
        MinusSignToParens,
        CommonModule,
        FormsModule,
        PlaceholderPipe,
        NgbModule,
        AdvisorContactComponent,
        VerticalNavComponent
    ]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
        ngModule: SharedModule,
        providers: []
    };
  }
}